// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
// - import Index from './resources/resources'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Agendamentos'))
]

export default subGroup('/schedulings', routes)



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/routes.js